import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, vShow as _vShow, withDirectives as _withDirectives, mergeProps as _mergeProps, withCtx as _withCtx, createTextVNode as _createTextVNode, withModifiers as _withModifiers, Teleport as _Teleport, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "fixed inset-0 z-50 flex justify-center bg-black/60" }
const _hoisted_2 = { class: "p-0 bg-gray-50 shadow-xl border border-gray-200 rounded-md text-center" }
const _hoisted_3 = { class: "flex flex-col w-full text-black" }
const _hoisted_4 = {
  key: 0,
  class: "absolute inset-0 flex items-center justify-center z-50 bg-black/20"
}
const _hoisted_5 = { class: "flex flex-col w-full rounded-t-md p-3 bg-gradient-to-r bg-[#243665]" }
const _hoisted_6 = { class: "font-semibold text-white text-sm md:text-2xl truncate whitespace-nowrap overflow-hidden text-ellipsis" }
const _hoisted_7 = { class: "container p-4 text-left space-y-3" }
const _hoisted_8 = { class: "w-full text-center" }
const _hoisted_9 = { class: "bg-red-100 text-sm border border-red-300 text-red-700 px-4 py-3 rounded relative" }
const _hoisted_10 = { class: "block sm:inline" }
const _hoisted_11 = { class: "flex flex-wrap -mx-2 space-y-4 md:space-y-0" }
const _hoisted_12 = { class: "w-full px-2 md:w-1/1" }
const _hoisted_13 = { class: "block mb-1" }
const _hoisted_14 = { class: "text-sm text-red-500 p-error" }
const _hoisted_15 = { class: "flex flex-wrap -mx-2 space-y-4 md:space-y-0" }
const _hoisted_16 = { class: "w-full px-2 md:w-1/1" }
const _hoisted_17 = { class: "block mb-1" }
const _hoisted_18 = { class: "text-sm text-red-500 p-error" }
const _hoisted_19 = { class: "flex flex-wrap -mx-2 space-y-4 md:space-y-0" }
const _hoisted_20 = { class: "w-full px-2 md:w-1/1" }
const _hoisted_21 = { class: "block mb-1" }
const _hoisted_22 = { class: "text-sm text-red-500 p-error" }
const _hoisted_23 = { class: "p-3 flex flex-col md:flex-row gap-2 justify-end w-full mt-2 bg-gray-100" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ProgressSpinner = _resolveComponent("ProgressSpinner")!
  const _component_InputText = _resolveComponent("InputText")!
  const _component_ErrorMessage = _resolveComponent("ErrorMessage")!
  const _component_Field = _resolveComponent("Field")!
  const _component_Form = _resolveComponent("Form")!
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!
  const _component_BlockUI = _resolveComponent("BlockUI")!

  return (_openBlock(), _createBlock(_Teleport, { to: "body" }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", {
        class: "m-5 w-full md:w-8/12 lg:w-4/12 xl:w-3/12",
        onClick: _cache[5] || (_cache[5] = _withModifiers(($event: any) => (_ctx.closeDialog(false)), ["self"]))
      }, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createVNode(_component_BlockUI, { blocked: _ctx.blocked }, {
              default: _withCtx(() => [
                (_ctx.blocked)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                      _createVNode(_component_ProgressSpinner, {
                        style: {"width":"50px","height":"50px"},
                        strokeWidth: "5",
                        fill: "transparent",
                        animationDuration: ".5s"
                      })
                    ]))
                  : _createCommentVNode("", true),
                _createElementVNode("div", _hoisted_5, [
                  _cache[6] || (_cache[6] = _createElementVNode("div", null, [
                    _createElementVNode("span", { class: "pi pi-lock w-6 h-6 text-white" })
                  ], -1)),
                  _createElementVNode("div", _hoisted_6, _toDisplayString(_ctx.$t('titulo.cambiar.password')), 1)
                ]),
                _createVNode(_component_Form, {
                  "validation-schema": _ctx.schema,
                  onInvalidSubmit: _ctx.onInvalidSubmit
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_7, [
                      _withDirectives(_createElementVNode("div", _hoisted_8, [
                        _createElementVNode("div", _hoisted_9, [
                          _createElementVNode("span", _hoisted_10, _toDisplayString(_ctx.errorCambioClave), 1)
                        ])
                      ], 512), [
                        [_vShow, _ctx.errorCambioClave]
                      ]),
                      _createElementVNode("div", _hoisted_11, [
                        _createElementVNode("div", _hoisted_12, [
                          _createElementVNode("label", _hoisted_13, _toDisplayString(_ctx.$t('label.clave.actual')), 1),
                          _createVNode(_component_Field, {
                            name: "claveActual",
                            modelValue: _ctx.claveActual,
                            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.claveActual) = $event))
                          }, {
                            default: _withCtx(({ field, errors }) => [
                              _createVNode(_component_InputText, _mergeProps(field, {
                                type: "password",
                                class: ["input-base", { 'bg-gray-50': errors.length === 0, 'input-success': errors.length === 0 && field.value !== '', 'input-error': errors.length > 0}]
                              }), null, 16, ["class"]),
                              _createElementVNode("span", _hoisted_14, [
                                _createVNode(_component_ErrorMessage, { name: "claveActual" })
                              ])
                            ]),
                            _: 1
                          }, 8, ["modelValue"])
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_15, [
                        _createElementVNode("div", _hoisted_16, [
                          _createElementVNode("label", _hoisted_17, _toDisplayString(_ctx.$t('label.clave.nueva')), 1),
                          _createVNode(_component_Field, {
                            name: "claveNueva",
                            modelValue: _ctx.claveNueva,
                            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.claveNueva) = $event))
                          }, {
                            default: _withCtx(({ field, errors }) => [
                              _createVNode(_component_InputText, _mergeProps(field, {
                                type: "password",
                                class: ["input-base", { 'bg-gray-50': errors.length === 0, 'input-success': errors.length === 0 && field.value !== '', 'input-error': errors.length > 0}]
                              }), null, 16, ["class"]),
                              _createElementVNode("span", _hoisted_18, [
                                _createVNode(_component_ErrorMessage, { name: "claveNueva" })
                              ])
                            ]),
                            _: 1
                          }, 8, ["modelValue"])
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_19, [
                        _createElementVNode("div", _hoisted_20, [
                          _createElementVNode("label", _hoisted_21, _toDisplayString(_ctx.$t('label.clave.nueva.repetir')), 1),
                          _createVNode(_component_Field, {
                            name: "claveRepetida",
                            modelValue: _ctx.claveRepetida,
                            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.claveRepetida) = $event))
                          }, {
                            default: _withCtx(({ field, errors }) => [
                              _createVNode(_component_InputText, _mergeProps(field, {
                                type: "password",
                                class: ["input-base", { 'bg-gray-50': errors.length === 0, 'input-success': errors.length === 0 && field.value !== '', 'input-error': errors.length > 0}]
                              }), null, 16, ["class"]),
                              _createElementVNode("span", _hoisted_22, [
                                _createVNode(_component_ErrorMessage, { name: "claveRepetida" })
                              ])
                            ]),
                            _: 1
                          }, 8, ["modelValue"])
                        ])
                      ])
                    ])
                  ]),
                  _: 1
                }, 8, ["validation-schema", "onInvalidSubmit"]),
                _createElementVNode("div", _hoisted_23, [
                  _createElementVNode("a", {
                    onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.closeDialog(false))),
                    class: "cursor-pointer px-4 py-2 bg-transparent border-red-600 hover:bg-red-600 text-red-600 font-semibold hover:text-white border rounded-xl"
                  }, [
                    _createVNode(_component_font_awesome_icon, { icon: ['fas', 'fa-xmark'] }),
                    _createTextVNode(" " + _toDisplayString(_ctx.$t('boton.cancelar')), 1)
                  ]),
                  _createElementVNode("a", {
                    onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.aplicarCambios && _ctx.aplicarCambios(...args))),
                    class: "cursor-pointer px-4 py-2 bg-transparent border-[#243665] hover:bg-[#243665] text-[#243665] font-semibold hover:text-white border rounded-xl"
                  }, [
                    _createVNode(_component_font_awesome_icon, { icon: ['fas', 'fa-check-double'] }),
                    _createTextVNode(" " + _toDisplayString(_ctx.$t('boton.aceptar')), 1)
                  ])
                ])
              ]),
              _: 1
            }, 8, ["blocked"])
          ])
        ])
      ])
    ])
  ]))
}